import { normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, renderList as _renderList, Fragment as _Fragment, resolveComponent as _resolveComponent, createVNode as _createVNode } from "vue"

const _hoisted_1 = ["title"]
const _hoisted_2 = { class: "text-center" }
const _hoisted_3 = ["aria-label"]
const _hoisted_4 = { class: "fw-bold text-dark" }
const _hoisted_5 = {
  class: "text-muted",
  style: {"font-size":"0.7rem"}
}
const _hoisted_6 = { class: "text-center text-nowrap small" }
const _hoisted_7 = { class: "text-truncate" }
const _hoisted_8 = { class: "text-center" }
const _hoisted_9 = { class: "badge bg-secondary" }
const _hoisted_10 = { class: "text-center" }
const _hoisted_11 = ["title"]
const _hoisted_12 = {
  key: 1,
  class: "text-muted"
}
const _hoisted_13 = { class: "text-center" }
const _hoisted_14 = { class: "text-center" }
const _hoisted_15 = { class: "text-center" }
const _hoisted_16 = { key: 0 }
const _hoisted_17 = {
  key: 1,
  class: "text-muted"
}
const _hoisted_18 = { class: "text-center" }
const _hoisted_19 = { key: 0 }
const _hoisted_20 = {
  key: 1,
  class: "text-muted"
}
const _hoisted_21 = { class: "text-center" }
const _hoisted_22 = { class: "text-center" }
const _hoisted_23 = {
  key: 0,
  class: "fas fa-edit text-warning",
  title: "Mensaje editado"
}
const _hoisted_24 = {
  key: 1,
  class: "fas fa-trash text-danger",
  title: "Mensaje eliminado"
}
const _hoisted_25 = {
  key: 2,
  class: "text-muted"
}
const _hoisted_26 = {
  key: 0,
  class: "bg-light"
}
const _hoisted_27 = {
  colspan: "10",
  class: "p-4"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_AlertDetails = _resolveComponent("AlertDetails")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("tr", {
      onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.toggleExpand && _ctx.toggleExpand(...args))),
      style: {"cursor":"pointer"},
      class: _normalizeClass({ 'table-warning': _ctx.hasPipsError(_ctx.alert) }),
      title: 
      _ctx.hasPipsError(_ctx.alert)
        ? 'Advertencia: Datos de trading inconsistentes (verificar dirección, SL, TP)'
        : ''
    
    }, [
      _createElementVNode("td", _hoisted_2, [
        _createElementVNode("i", {
          class: _normalizeClass([
          'fas',
          _ctx.isExpanded ? 'fa-chevron-down' : 'fa-chevron-right',
          'fa-fw',
          'm-1',
          'text-secondary',
        ])
        }, null, 2)
      ]),
      _createElementVNode("td", {
        class: "text-center",
        style: {"vertical-align":"middle"},
        "aria-label": `Número de alerta ${_ctx.rowNumber}`
      }, [
        _createElementVNode("div", _hoisted_4, _toDisplayString(_ctx.rowNumber), 1),
        _createElementVNode("div", _hoisted_5, "#" + _toDisplayString(_ctx.alert.mainMessage.messageId), 1)
      ], 8, _hoisted_3),
      _createElementVNode("td", _hoisted_6, _toDisplayString(_ctx.formatDate(_ctx.alert.mainMessage.date)), 1),
      _createElementVNode("td", null, [
        _createElementVNode("div", _hoisted_7, _toDisplayString(_ctx.cleanAlertText(_ctx.getAlertSummary(_ctx.alert))), 1)
      ]),
      _createElementVNode("td", _hoisted_8, [
        _createElementVNode("span", _hoisted_9, _toDisplayString(_ctx.alertType === _ctx.AlertType.FOREX
          ? _ctx.alert.mainMessage.pair || "-"
          : _ctx.alert.mainMessage.index || "-"), 1)
      ]),
      _createElementVNode("td", _hoisted_10, [
        (_ctx.alert.mainMessage.orderType)
          ? (_openBlock(), _createElementBlock("span", {
              key: 0,
              class: _normalizeClass(["badge", _ctx.getOrderTypeBadgeClass(_ctx.alert.mainMessage.orderType)]),
              title: _ctx.getOrderTypeLabel(_ctx.alert.mainMessage.orderType)
            }, _toDisplayString(_ctx.getOrderTypeShortLabel(_ctx.alert.mainMessage.orderType)), 11, _hoisted_11))
          : (_openBlock(), _createElementBlock("span", _hoisted_12, "-"))
      ]),
      _createElementVNode("td", _hoisted_13, [
        _createElementVNode("span", {
          class: _normalizeClass(["badge", 
          _ctx.alert.mainMessage.direction?.toLowerCase() === 'buy'
            ? 'bg-success'
            : 'bg-danger'
        ])
        }, _toDisplayString(_ctx.alert.mainMessage.direction || "-"), 3)
      ]),
      _createElementVNode("td", _hoisted_14, [
        _createTextVNode(_toDisplayString(_ctx.formatPrice(_ctx.alert.mainMessage.entryPrice)) + " ", 1),
        _createElementVNode("div", {
          class: _normalizeClass(["small", 
          _ctx.getRRColorClass(
            _ctx.alert.mainMessage.entryPrice,
            _ctx.alert.mainMessage.stopLoss,
            _ctx.alert.mainMessage.takeProfit
          ) || 'text-muted'
        ]),
          style: {"font-size":"0.75rem","line-height":"1.1"}
        }, _toDisplayString(_ctx.calculateRR(
            _ctx.alert.mainMessage.entryPrice,
            _ctx.alert.mainMessage.stopLoss,
            _ctx.alert.mainMessage.takeProfit
          )), 3)
      ]),
      _createElementVNode("td", _hoisted_15, [
        (
          _ctx.alert.mainMessage.takeProfit && _ctx.alert.mainMessage.takeProfit.length
        )
          ? (_openBlock(), _createElementBlock("div", _hoisted_16, [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.alert.mainMessage.takeProfit, (tp, index) => {
                return (_openBlock(), _createElementBlock("div", { key: index }, [
                  _createElementVNode("div", null, _toDisplayString(_ctx.formatPrice(tp)), 1),
                  _createElementVNode("div", {
                    class: _normalizeClass(["small", 
              _ctx.calculatePips(
                _ctx.alert.mainMessage.entryPrice,
                tp,
                _ctx.alert.mainMessage.pair || _ctx.alert.mainMessage.index,
                _ctx.alertType,
                _ctx.alert.mainMessage.direction,
                _ctx.alert.mainMessage.stopLoss
              ).includes('ERROR')
                ? 'text-danger fw-bold'
                : 'text-muted'
            ]),
                    style: {"font-size":"0.75rem","line-height":"1.1"}
                  }, _toDisplayString(_ctx.calculatePips(
                _ctx.alert.mainMessage.entryPrice,
                tp,
                _ctx.alert.mainMessage.pair || _ctx.alert.mainMessage.index,
                _ctx.alertType,
                _ctx.alert.mainMessage.direction,
                _ctx.alert.mainMessage.stopLoss
              )), 3)
                ]))
              }), 128))
            ]))
          : (_openBlock(), _createElementBlock("span", _hoisted_17, "-"))
      ]),
      _createElementVNode("td", _hoisted_18, [
        (_ctx.alert.mainMessage.stopLoss)
          ? (_openBlock(), _createElementBlock("div", _hoisted_19, [
              _createElementVNode("div", null, _toDisplayString(_ctx.formatPrice(_ctx.alert.mainMessage.stopLoss)), 1),
              _createElementVNode("div", {
                class: _normalizeClass(["small", 
            _ctx.calculatePips(
              _ctx.alert.mainMessage.entryPrice,
              _ctx.alert.mainMessage.stopLoss,
              _ctx.alert.mainMessage.pair || _ctx.alert.mainMessage.index,
              _ctx.alertType,
              _ctx.alert.mainMessage.direction,
              _ctx.alert.mainMessage.stopLoss
            ).includes('ERROR')
              ? 'text-danger fw-bold'
              : 'text-muted'
          ]),
                style: {"font-size":"0.75rem","line-height":"1.1"}
              }, _toDisplayString(_ctx.calculatePips(
              _ctx.alert.mainMessage.entryPrice,
              _ctx.alert.mainMessage.stopLoss,
              _ctx.alert.mainMessage.pair || _ctx.alert.mainMessage.index,
              _ctx.alertType,
              _ctx.alert.mainMessage.direction,
              _ctx.alert.mainMessage.stopLoss
            )), 3)
            ]))
          : (_openBlock(), _createElementBlock("span", _hoisted_20, "-"))
      ]),
      _createElementVNode("td", _hoisted_21, [
        _createElementVNode("span", {
          class: _normalizeClass(["badge", _ctx.getResultBadgeClass(_ctx.alert.resultStatus)])
        }, _toDisplayString(_ctx.getResultLabel(_ctx.alert.resultStatus)), 3)
      ]),
      _createElementVNode("td", _hoisted_22, [
        (_ctx.hasEditedMessages(_ctx.alert))
          ? (_openBlock(), _createElementBlock("i", _hoisted_23))
          : (_ctx.hasDeletedMessages(_ctx.alert))
            ? (_openBlock(), _createElementBlock("i", _hoisted_24))
            : (_openBlock(), _createElementBlock("span", _hoisted_25, "-"))
      ])
    ], 10, _hoisted_1),
    (_ctx.isExpanded)
      ? (_openBlock(), _createElementBlock("tr", _hoisted_26, [
          _cache[5] || (_cache[5] = _createElementVNode("td", {
            colspan: "2",
            class: "bg-secondary bg-gradient",
            style: {"--bs-bg-opacity":"0.1"}
          }, null, -1)),
          _createElementVNode("td", _hoisted_27, [
            _createVNode(_component_AlertDetails, {
              alert: _ctx.alert,
              "is-editing": _ctx.isEditing,
              "is-saving": _ctx.isSaving,
              "is-reprocessing": _ctx.isReprocessing,
              "current-alert-type": _ctx.alertType,
              onStartEdit: _cache[1] || (_cache[1] = ($event: any) => (_ctx.$emit('start-edit', $event))),
              onCancelEdit: _cache[2] || (_cache[2] = ($event: any) => (_ctx.$emit('cancel-edit'))),
              onSaveEdit: _cache[3] || (_cache[3] = ($event: any) => (_ctx.$emit('save-edit', $event))),
              onReprocessMessage: _cache[4] || (_cache[4] = ($event: any) => (_ctx.$emit('reprocess-message', $event)))
            }, null, 8, ["alert", "is-editing", "is-saving", "is-reprocessing", "current-alert-type"])
          ])
        ]))
      : _createCommentVNode("", true)
  ], 64))
}